import React, { FC }  from "react";
import { Pagination } from "semantic-ui-react";
import CurrentPage    from "../../../domain/fundamentals/pagination/CurrentPage";
import TotalPage      from "../../../domain/fundamentals/pagination/TotalPage";

interface Props {
  currentPage: CurrentPage;
  totalPage: TotalPage;
  onChangePage: (currentPage: CurrentPage) => void;
}

const ListPagination: FC<Props> = (props: Props) => {
  const {currentPage, totalPage, onChangePage} = props;
  return (
    <>
      <Pagination
        totalPages={ totalPage.value }
        activePage={ currentPage.value }
        onPageChange={ (event, data) => onChangePage(new CurrentPage(Number(data.activePage))) }
      />
    </>
  );
};

export default ListPagination;
